<script setup lang="ts">
import CenterModal from "~/components/Common/Modals/CenterModal.vue";
import AppButton from "~/components/Common/Buttons/AppButton.vue";

const emit = defineEmits(["cancel"]);

const cancel = () => {
  emit("cancel");
};
</script>

<template>
  <CenterModal class="max-w-[488px] w-full">
    <template #body>
      <div class="p-[24px] flex flex-col gap-3">
        <div class="flex flex-col gap-6">
          <div>
            <div class="flex justify-center mb-[6px]">
              <img src="/icons/emojis/unhappy.svg" alt="" :style="{ height: '64px', width: '64px' }" />
            </div>
            <h3 class="heading_4_demi text-primary-color flex justify-center">Impossible de supprimer cette étape</h3>
            <p class="text-secondary-color mt-[6px] body_regular text-center">
              Une session doit avoir au moins une étape.
            </p>
          </div>
          <div class="flex justify-center">
            <AppButton label="OK" @click="cancel" />
          </div>
        </div>
      </div>
    </template>
  </CenterModal>
</template>

<style scoped></style>
